import './swiper.less';
import Utils from '@packages/utils/utils.js';
import EventBus from '@packages/utils/eventBus.js';
import Transition from '@packages/utils/transition.js';
import Extends from '@packages/utils/extends.js';

// touch事件
var touchEvents = {
  start: Utils.support.touch ? 'touchstart' : 'mousedown',
  move: Utils.support.touch ? 'touchmove' : 'mousemove',
  end: Utils.support.touch ? 'touchend' : 'mouseup'
};

var Swiper = function (el, options) {
  this.wrapper = typeof el === 'string' ? document.querySelector(el) : el;
  this.scroller = this.wrapper.querySelector('.bx-swiper-scroller');
  var defaults = {
    // 轮播组件的宽度,默认设备宽度
    width: null,
    // 轮播组件的高度, default、min、auto、数值
    height: null,
    // 轮播间隔事件
    speed: 5000,
    // 是否循环轮播
    loop: true,
    // 是否自动轮播
    autoplay: true,
    // 轮播动画时间
    transitionSpeed: 300,
    // 是否展示指示器/分页器
    pagination: true,
    // 页数大于当前值时,才展示分页器
    paginationLimit: 1,
    // 覆盖默认指示器/分页器样式
    paginationClass: null,
    // 指示器/分页器距离底部的距离
    paginationBottom: 9,
    // 滑动角度小于该值,才能正常滑动
    angle: 45,
    // 滑动结束后,时间小于{duration}毫秒并且距离大于{distance},即判定为滑动到上一个/下一个
    duration: 300,
    distance: 30,
    // 放大倍数, 根据viewport动态设置scale的值, 基本为1
    scale: null,
    // 是否开启回弹
    bounce: true,
    // 轮播相关事件
    onInit: Utils.noop,
    onTouchStart: Utils.noop,
    onTouchMove: Utils.noop,
    onTouchEnd: Utils.noop,
    onSlide: Utils.noop,
    onSlidePrev: Utils.noop,
    onSlideNext: Utils.noop,
    onTransitionEnd: Utils.noop
  }
  this.options = defaults;
  Extends(this.options, options);
  this.options.$parent = this;
  this.computedWidth = this.options.width;
  this.total = 0;
  this.loopTotal = 0;
  this.currentIndex = 0;
  this.timer = null;
  this.isTouchStart = false;
  this.isTouchEnd = false;
  this.direction = null;
  this.distance = 0;
  this.offset = {
    x: 0,  // 横向滑动距离
    y: 0   // 纵向滑动距离
  }
  this.touches = {
    startX: 0,  // touch前一个点
    startY: 0,  // touch前一个点
    currentX: 0, // touch后一个点
    currentY: 0, // touch后一个点
    distanceX: 0, // 两个touch之间的距离
    distanceY: 0  // 两个touch之间的距离
  }
  this.unique = this.options.unique || Utils.getUnique();
  this.init();
};
var startTime = 0;
var endTime = 0;
var duration = 0;
var isTouchEvent = false;
var isTouch = false;
var isSliding;
Swiper.prototype = {
  init: function () {
    var self = this;
    self.setWidth();
    self.setHeight();
    self.setIndex();
    self.setScale();
    self.total = self.getTotal();
    if (self.options.pagination && self.total > self.options.paginationLimit) {
      self.initPagination();
    }
    self.total <= 1 && (self.options.loop = false);
    self.options.loop && self.createLoop();
    self.options.autoplay && self.startInterval(self.options.speed);
    self.observer = EventBus.create(self.unique);
    self._addEvent();
    self.observer.emit('onInit');
  },
  // 设置容器宽度
  setWidth: function () {
    var self = this;
    var _width = 0;

    if (self.options.width) {
      self.wrapper.style.width = Utils.isPercentage(self.options.width) ? self.options.width : self.options.width + 'px';
    }
    _width = self.wrapper.clientWidth;
    self.computedWidth = _width;
  },
  // 设置容器高度
  setHeight: function () {
    var self = this;
    if (self.options.height) {
      if (Utils.isPercentage(self.options.height)) {
        self.wrapper.style['height'] = self.computedWidth * Utils.percentageToNumber(self.options.height) + 'px';
      } else {
        self.wrapper.style['height'] = self.options.height + 'px';
      }
    } else {
      self.wrapper.style['height'] = '100%';
    }
  },
  // 设置元素放大倍数
  setScale: function () {
    var self = this;
    if (!self.options.scale) {
      self.options.scale = Utils.getScale();
    }
  },
  // autopaly为true,开启轮播定时器
  startInterval: function (speed) {
    var self = this;
    self.timer = window.setInterval(function () {
      if (self.isTouchStart) {
        if (self.isTouchEnd) {
          self.isTouchStart = false;
          self.isTouchEnd = false;
        }
        return false;
      }
      self.next();
    }, speed);
  },
  // 获取当前轮播个数
  getTotal: function () {
    var self = this;
    var items = self.wrapper.querySelectorAll('.bx-swiper-slide');
    return items.length;
  },
  // 设置轮播项index
  setIndex: function () {
    var self = this;
    var items = self.wrapper.querySelectorAll('.bx-swiper-slide');
    for (var index = 0; index < items.length; index++) {
      items[index].setAttribute('data-slide-index', index);
    }
  },
  // 获取当前轮播项index
  getIndex: function () {
    var self = this;
    var items = self.wrapper.querySelectorAll('.bx-swiper-slide');
    var currentIndex = 0;
    for (var index = 0; index < items.length; index++) {
      if (Utils.hasClass(items[index], 'bx-swiper-slide--active')) {
        currentIndex = items[index].getAttribute('data-slide-index');
      }
    }
    return currentIndex;
  },
  // 滚动到指定的x轴/y轴位置, time为动画时间
  slideTo: function (x, y, time) {
    var self = this;
    Transition.setProperty(self.scroller, Transition.prefixStyle('transform'));
    time !== 0 && (time = self.options.transitionSpeed);
    Transition.setDuration(self.scroller, time);
    self._translate(x, y);
  },
  // 滚动到指定的index
  slideToIndex: function (index, type) {
    var self = this;
    if (self.options.loop) {
      if (type === 'prev') {
        if (index === (self.total - 1)) {
          self.slideTo(0, 0);
        } else {
          self.slideTo(-1 * (index + 1) * self.computedWidth, 0);
        }
      } else {
        if (index === 0) {
          self.slideTo(-1 * (self.loopTotal - 1) * self.computedWidth, 0);
        } else {
          self.slideTo(-1 * (index + 1) * self.computedWidth, 0);
        }
      }
    } else {
      self.slideTo(-1 * index * self.computedWidth, 0);
    }

    self.setItemActive();
    self.options.pagination && self.setPaginationActive();
    self.observer.emit('onSlide');
  },
  // 更新index位置
  updateIndex: function () {
    var self = this;
    if (self.options.loop) {
      self.slideTo(-1 * (self.currentIndex + 1) * self.computedWidth, 0, 0);
    } else {
      self.slideTo(-1 * self.currentIndex * self.computedWidth, 0, 0);
    }
  },
  // 设置当前index的轮播项为活动状态
  setItemActive: function () {
    var self = this;
    var items = self.wrapper.querySelectorAll('.bx-swiper-slide');
    for (var index = 0; index < items.length; index++) {
      if (items[index].getAttribute('data-slide-index') === self.currentIndex) {
        !Utils.hasClass(items[index], 'bx-swiper-slide--active') && Utils.addClass(items[index], 'bx-swiper-slide--active')
      } else {
        Utils.hasClass(items[index], 'bx-swiper-slide--active') && Utils.removeClass(items[index], 'bx-swiper-slide--active')
      }
    }
  },
  // 初始化指示器/分页器
  initPagination: function () {
    var self = this;
    var div = document.createElement('div');
    div.className = self.options.paginationClass ? ('bx-swiper-paginations ' + self.options.paginationClass) : 'bx-swiper-paginations';
    var html = '';
    for (var i = 0; i < self.total; i++) {
      html += '<div class="bx-swiper-pagination' + (i === 0 ? ' bx-swiper-pagination--active' : '') + '"></div>';
    }
    div.innerHTML = html;
    // 使用该方案, 分页器会模糊
    // div.style.bottom = (self.options.paginationBottom * self.options.scale) + 'px';
    // self.options.scale != 1 && Utils.setScale(div, self.options.scale);
    div.style.bottom = (self.options.paginationBottom / self.options.scale) + 'px';
    self.options.scale !== 1 && (div.style.zoom = self.options.scale);
    self.wrapper.appendChild(div);
  },
  // 设置当前index的指示器/分页器为活动状态
  setPaginationActive: function () {
    var self = this;
    var items = self.wrapper.querySelectorAll('.bx-swiper-pagination');
    for (var index = 0; index < items.length; index++) {
      if (index === self.currentIndex) {
        !Utils.hasClass(items[index], 'bx-swiper-pagination--active') && Utils.addClass(items[index], 'bx-swiper-pagination--active');
        !Utils.hasClass(items[index], 'bx-swiper-pagination--translation') && Utils.addClass(items[index], 'bx-swiper-pagination--translation');
      } else {
        Utils.hasClass(items[index], 'bx-swiper-pagination--active') && Utils.removeClass(items[index], 'bx-swiper-pagination--active');
        Utils.hasClass(items[index], 'bx-swiper-pagination--translation') && Utils.removeClass(items[index], 'bx-swiper-pagination--translation');
      }
    }
  },
  // 滑动到上一个
  prev: function () {
    var self = this;
    self.currentIndex--;
    if (self.currentIndex < 0) {
      self.currentIndex = self.total - 1;
    }
    self.slideToIndex(self.currentIndex, 'prev');
    self.observer.emit('onSlidePrev');
  },
  // 滑动到下一个
  next: function () {
    var self = this;
    self.currentIndex++;
    if (self.currentIndex >= self.total) {
      self.currentIndex = 0;
    }
    self.slideToIndex(self.currentIndex, 'next');
    self.observer.emit('onSlideNext');
  },
  // 初始化循环滚动
  createLoop: function () {
    var self = this;
    var items = self.wrapper.querySelectorAll('.bx-swiper-slide');
    var firstNode = items[0].cloneNode(true);
    Utils.removeClass(firstNode, 'bx-swiper-slide--active');
    var lastNode = items[items.length - 1].cloneNode(true);
    self.scroller.insertBefore(lastNode, items[0]);
    self.scroller.appendChild(firstNode);
    self.loopTotal = self.getTotal();
    // 定位到第一个slideitem
    self._translate(-1 * self.computedWidth, 0);
  },
  // 处理循环滚动位置
  handleLoop: function () {
    var self = this;
    if (self.offset.x === 0) {
      self.slideTo(-1 * self.total * self.computedWidth, 0, 0);
    }
    if (self.offset.x === -1 * (self.loopTotal - 1) * self.computedWidth) {
      self.slideTo(-1 * self.computedWidth, 0, 0);
    }
  },
  // 统一事件处理中心
  handleEvent: function (e) {
    switch (e.type) {
      case 'touchstart':
        this._onTouchStart(e);
        break;
      case 'touchmove':
        this._onTouchMove(e);
        break;
      case 'touchend':
        this._onTouchEnd(e);
        break;
      case 'mousedown':
        this._onTouchStart(e);
        break;
      case 'mousemove':
        this._onTouchMove(e);
        break;
      case 'mouseup':
        this._onTouchEnd(e);
        break;
      case 'transitionend':
        this._transitionEnd(e);
        break;
      case 'webkitTransitionEnd':
        this._transitionEnd(e);
        break;
      case 'resize':
        this._onResize(e);
        break;
    }
  },
  // 判断是否需要回弹
  setBounce: function () {
    var self = this;
    if (!self.options.loop) {
      if (self.currentIndex === 0 && self.direction === 'right') {
        return true;
      }
      if (self.currentIndex === (self.total - 1) && self.direction === 'left') {
        return true;
      }
    }
    return false;
  },
  // 添加事件
  _addEvent: function () {
    var self = this;
    this.wrapper['addEventListener'](touchEvents.start, this, false);
    this.wrapper['addEventListener'](touchEvents.move, this, false);
    this.wrapper['addEventListener'](touchEvents.end, this, false);
    if (Utils.support.touch && !Utils.env.isIos && !Utils.env.isAndroid) {
      this.wrapper['addEventListener']('mousedown', this, false);
      this.wrapper['addEventListener']('mousemove', this, false);
      this.wrapper['addEventListener']('mouseup', this, false);
    }
    this.scroller['addEventListener']('transitionend', this, false);
    this.scroller['addEventListener']('webkitTransitionEnd', this, false);
    window['addEventListener']('resize', this, false);
    for (var item in self.options) {
      if (item.indexOf('on') === 0) {
        if (self.options[item] instanceof Function) {
          (function (item, _self) {
            _self.observer.on(item, function () {
              _self.options[item].apply(_self, Array.prototype.slice.call(arguments));
            });
          })(item, self)
        }
      }
    }
  },
  _onTouchStart: function (e) {
    var self = this;
    // 兼容jq自己封装的originalEvent,指向原始的事件对象
    if (e.originalEvent) e = e.originalEvent;
    // 大于一个touch点,不做处理
    if (e.touches && e.touches.length > 1) {
      e.preventDefault();
      return;
    }
    isTouchEvent = (e.type === 'touchstart');
    isTouch = true;
    isSliding = undefined;
    self.touches.startX = (isTouchEvent ? e.touches[0].pageX : e.pageX);
    self.touches.startY = (isTouchEvent ? e.touches[0].pageY : e.pageY);
    startTime = Utils.now();
    self.distance = 0;
    self.isTouchStart = true;
    Transition.setDuration(self.scroller, 0);
    self.observer.emit('onTouchStart');
  },
  _onTouchMove: function (e) {
    var self = this;
    if (e.originalEvent) e = e.originalEvent;
    if (!isTouch && e.type === 'mousemove') {
      e.preventDefault();
      return;
    }
    self.options.loop && self.handleLoop();
    if (e.touches && e.touches.length > 1) {
      e.preventDefault();
      return;
    }
    self.touches.currentX = (e.type === 'touchmove' ? e.touches[0].pageX : e.pageX);
    self.touches.currentY = (e.type === 'touchmove' ? e.touches[0].pageY : e.pageY);
    var touchAngle = Math.atan2(Math.abs(self.touches.currentY - self.touches.startY), Math.abs(self.touches.currentX - self.touches.startX)) * 180 / Math.PI;
    if (typeof isSliding === 'undefined') {
      isSliding = (touchAngle <= self.options.angle);
    }
    if (!isSliding) {
      return;
    }
    self.touches.distanceX = self.touches.currentX - self.touches.startX;
    self.touches.distanceY = self.touches.currentY - self.touches.startY;
    self.touches.distanceX > 0 ? self.direction = 'right' : self.direction = 'left';
    self.options.bounce && (self.bounce = self.setBounce());
    self.bounce && (self.touches.distanceX = self.touches.distanceX / 2);
    self.offset.x += self.touches.distanceX;
    self.distance += self.touches.distanceX;
    self._translate(self.offset.x, 0);
    self.touches.startX = self.touches.currentX;
    self.touches.startY = self.touches.currentY;
    e.preventDefault();
    self.observer.emit('onTouchMove');
  },
  _onTouchEnd: function (e) {
    var self = this;
    endTime = Utils.now();
    duration = endTime - startTime;
    if (!self.bounce && ((duration <= self.options.duration && Math.abs(self.distance) > self.options.distance) || Math.abs(self.distance) > self.computedWidth / 2)) {
      self.distance > 0 ? self.prev() : self.next();
    } else {
      self.slideTo(self.offset.x - self.distance, 0);
    }
    isTouch = false;
    self.isTouchEnd = true;
    self.observer.emit('onTouchEnd');
  },
  _onResize: function (e) {
    var self = this;
    self.setWidth();
    self.setHeight();
    self.updateIndex();
  },
  // transition动画结束后回调
  _transitionEnd: function (e) {
    var self = this;
    self.options.loop && self.handleLoop();
    self.observer.emit('onTransitionEnd');
  },
  // 页面滑动到指定位置
  _translate: function (x, y) {
    var self = this;
    if (!self.options.bounce) {
      if (x > 0) {
        x = 0;
      }
      var total = self.options.loop ? self.loopTotal : self.total;
      var totalDistance = (total - 1) * self.computedWidth;
      if (Math.abs(x) > totalDistance) {
        x = -1 * totalDistance;
      }
    }
    self.offset.x = x;
    Transition.setTransform(self.scroller, x, y);
  }
}
export default {
  create: function (el, options) {
    return new Swiper(el, options);
  }
}



// WEBPACK FOOTER //
// ./packages/components/swiper/swiper.js